// src/app/pipes/asset-path.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '../services/config.service';

@Pipe({
  name: 'assetPath',
  pure: true
})
export class AssetPathPipe implements PipeTransform {
  constructor(private configService: ConfigService) {}

  transform(value: string, path?: string): string {
    let relativePath = this.configService.getAssetPath();
    let basePathPath = this.configService.getBasePath();
    if (path?.includes('dist/ng-presse')) {
        return `${basePathPath}${value}`;
    }
    return `${relativePath}${value}`;
  }
}
